import { FC } from "react";

import { ErrorNotFound } from "./components/ErrorNotFound";
import { ErrorLayoutProps, ErrorType } from "./ErrorLayout.types";

export const ErrorLayout: FC<ErrorLayoutProps> = ({ type, content }) => {
    switch (type) {
        case ErrorType.REFERRAL:
        case ErrorType.ADVOCATE:
            return <ErrorNotFound {...content[type]} errorType={type} />;

        default:
            return (
                <ErrorNotFound
                    {...content[ErrorType.NOT_FOUND]}
                    errorType={ErrorType.NOT_FOUND}
                />
            );
    }
};
